export const MASKED_ZIP_CODE_LENGTH = 9
